import React from 'react';
import {
  CSelect,
} from '@coreui/react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { fetchOrganizationsForSelect, setOrganization } from './actions';
import './styles.scss';
import { disabledPathes } from '../constants';
import useGlobalSelectionsContext from '../../../core/hooks/useGlobalSelectionsContext';

const OrganizationSelectContainer = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const {
    organizations, organizationId, initiativeId, organizationsOnLoading, initiativesOnLoading,
  } = useSelector(({ globalSelections }) => globalSelections);
  const { hideOrganizationsSelect, adminMode, isInitiativeEmpty } = useGlobalSelectionsContext();

  React.useEffect(() => {
    if (organizations.length > 0) dispatch(setOrganization(organizations[0].id));
  }, [organizations, dispatch]);

  React.useEffect(() => {
    if (!adminMode && !isInitiativeEmpty) {
      dispatch(fetchOrganizationsForSelect(initiativeId));
    }
    // eslint-disable-next-line
  }, [initiativeId, adminMode, dispatch]);

  const onOrganizationSelectChange = React.useCallback(({ target }) => {
    dispatch(setOrganization(target.value));
  }, [dispatch]);

  const isDisabled = React.useMemo(
    () => disabledPathes.some((path) => pathname.includes(path)),
    [pathname],
  );

  if (hideOrganizationsSelect) return null;

  return (
    <div className="organization-select">
      <CSelect
        custom
        name="organizations"
        id="organizations"
        value={organizationId}
        onChange={onOrganizationSelectChange}
        className="mxw-20rem mxw-100-xs mr-2"
        disabled={isDisabled || organizationsOnLoading || initiativesOnLoading}
      >
        <option disabled value={0}>Select Organization</option>
        {organizations.map(((o) => (
          <option value={o.id} key={o.id}>{o.name}</option>
        )))}
      </CSelect>
    </div>
  );
};

export default OrganizationSelectContainer;
